import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ShouldLoginComponent } from './core/components/should-login/should-login.component';
import { UnauthorizedAccessComponent } from './core/components/unauthorized-access/unauthorized-access.component';
import { InvalidAccountComponent } from './core/components/invalid-account/invalid-account.component';
import { InvalidAccountGuard } from './core/guards/invalid-account.guard';
import { ROUTES } from 'src/app/core/constants/routes-constants';
import { LogoutComponent } from './core/components/logout/logout.component';
import { userRedirectResolver } from './core/resolve/user.resolver';
import { UserRedirectComponent } from './features/user-redirect/user-redirect.component';
import { AuthorizeGuard } from './core/guards/authorize.guard';

const routes: Routes = [
  {
    path: '',
    component: UserRedirectComponent,
    pathMatch: 'full',
    resolve: { redirect: userRedirectResolver },
    canActivate: [AuthorizeGuard],
  },
  { path: ROUTES.SHOULD_LOGIN_ROUTE_URL, component: ShouldLoginComponent },
  { path: ROUTES.UNAUTHORIZED_ROUTE_URL, component: UnauthorizedAccessComponent },
  { path: ROUTES.INVALID_ACCOUNT, component: InvalidAccountComponent, canActivate: [InvalidAccountGuard] },
  { path: `${ROUTES.AUTHENTICATION}/${ROUTES.LOGOUT}`, component: LogoutComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
